<template>
    <div class="page-container" v-bind:class="{ squishy: isActive }">
        <vapp-loadingspinner></vapp-loadingspinner>
        <vue-drawer-layout
                class="vue-drawer-layout"
                ref="drawer"
                :drawer-width="280"
                v-bind:enable="drawerEnabled"
                :animatable="true"
                :z-index="0"
                :drawable-distance="280"
                :content-drawable="true"
                :backdrop="true"
                :backdrop-opacity-range="[0,0.4]"
                @mask-click="handleMaskClick">
            <div class="drawer-content" slot="drawer">
                <div class="vue-drawer-toolbar">
                    <div class="user-image">
                        <img :src="user.picture.url" v-if="user.picture">
                        <img src="@/assets/images/ic_woman.svg" v-else/>
                    </div>
                    <div class="user-name-company">
                        <span>{{ user.display_name }} |</span>
                        <span>
                            <select v-model="app_company" @change="selectCompany(app_company)">
                                <option v-for="(value, key, index) in companies" v-bind:value="value.id">{{ value.display_name }}</option>
                            </select>
                        </span>
                    </div>
                </div>

                <md-list>
                    <!-- Dashboard -->
                    <md-list-item v-if="$route.name == 'dashboard'">
                        <div class="drawer-icon-container active">
                            <img src="@/assets/images/ic_home_white.svg" alt="">
                        </div>
                        <span class="md-list-item-text" @click="handleMaskClick">
                            <router-link to="/"><span class="span-selected">Home</span></router-link>
                        </span>
                    </md-list-item>
                    <md-list-item v-else>
                        <div class="drawer-icon-container">
                            <img src="@/assets/images/ic_home.svg" alt="">
                        </div>
                        <span class="md-list-item-text" @click="handleMaskClick">
                          <router-link to="/"><span class="span-unselected">Home</span></router-link>
                        </span>
                    </md-list-item>
                    <!-- Invoice -->
                    <md-list-item
                            :class="{ 'active-dropdown': invoice_clicked }"
                            v-if="$route.name == 'invoice' || $route.name == 'create_invoice'"
                            @click="toggleInvoiceDropdown">
                        <div class="drawer-icon-container active">
                            <img src="@/assets/images/ic_invoices_white.svg" alt="">
                        </div>
                        <span class="md-list-item-text">Invoices</span>
                        <span class="float-right count">{{ num_of_invoices }}</span>
                        <span class="float-right menu-icon">
                            <img src="@/assets/images/drawer-menu-dropdown.svg" />
                        </span>
                    </md-list-item>
                    <md-list-item v-else
                                  :class="{ 'active-dropdown': invoice_clicked }"
                                  @click="toggleInvoiceDropdown">
                        <div class="drawer-icon-container">
                            <img src="@/assets/images/ic_invoices.svg" alt="">
                        </div>
                        <span class="md-list-item-text">Invoices</span>
                        <span class="float-right count">{{ num_of_invoices }}</span>
                        <span class="float-right menu-icon">
                          <img src="@/assets/images/drawer-menu-dropdown.svg" />
                        </span>
                    </md-list-item>
                    <transition name="fade" mode="in-out">
                        <div v-if="invoice_clicked" class="sub-item">
                            <!-- All Items -->
                            <div v-if="$route.name == 'invoice' && $route.params.cat == 'all'" @click="handleMaskClick" class="noDeco">
                                <router-link to="/invoices/all" class="sub-item-active"><span class="span-selected" >All Invoices</span></router-link>
                            </div>
                            <div v-else @click="handleMaskClick">
                                <router-link to="/invoices/all"><span class="span-unselected">All Invoices</span></router-link>
                            </div>

                            <!-- Create Item -->
                            <div v-if="$route.name == 'create_invoice'" @click="handleMaskClick">
                                <router-link to="/create_invoice" class="sub-item-active"><span class="span-selected">New Invoice</span></router-link>
                            </div>
                            <div v-else @click="handleMaskClick">
                                <router-link to="/create_invoice"><span class="span-unselected">New Invoice</span></router-link>
                            </div>

                            <!--Personalize Invoice-->
                            <div v-if="$route.name == 'invoice_personalization'" @click="handleMaskClick">
                                <router-link to="/invoice_personalization" class="sub-item-active"><span class="span-selected">Personalize Invoice</span></router-link>
                            </div>
                            <div v-else @click="handleMaskClick">
                                <router-link to="/invoice_personalization"><span class="span-unselected">Personalize Invoice</span></router-link>
                            </div>

                        </div>
                    </transition>

                    <!-- Contact -->
                    <md-list-item v-if="$route.name == 'contact'">
                        <div class="drawer-icon-container active">
                            <img src="@/assets/images/ic_contacts_white.svg" alt="">
                        </div>
                        <span class="md-list-item-text" @click="handleMaskClick">
                          <router-link to="/contacts/all"><span class="span-selected">Contacts</span></router-link>
                        </span>
                        <span class="float-right count">{{ num_of_contacts }}</span>
                        <span class="float-right menu-icon invisible">
                            <img src="@/assets/images/drawer-menu-dropdown.svg" />
                        </span>
                    </md-list-item>
                    <md-list-item v-else>
                        <div class="drawer-icon-container">
                            <img src="@/assets/images/ic_contacts.svg" alt="">
                        </div>
                        <span class="md-list-item-text" @click="handleMaskClick">
                            <router-link to="/contacts/all"><span class="span-unselected">Contacts</span></router-link>
                        </span>
                        <span class="float-right count">{{ num_of_contacts }}</span>
                        <span class="float-right menu-icon invisible">
                            <img src="@/assets/images/drawer-menu-dropdown.svg" />
                        </span>
                    </md-list-item>
                    <!-- Item -->
                    <md-list-item v-if="$route.name.includes('item')"
                                  :class="{ 'active-dropdown': item_clicked }"
                                  @click="toggleItemDropdown">
                        <div class="drawer-icon-container active">
                            <img src="@/assets/images/ic_items_white.svg" alt="">
                        </div>
                        <span class="md-list-item-text">Items</span>
                        <span class="float-right count">{{ num_of_items }}</span>
                        <span class="float-right menu-icon">
                            <img src="@/assets/images/drawer-menu-dropdown.svg" />
                        </span>
                    </md-list-item>
                    <md-list-item v-else
                                  :class="{ 'active-dropdown': item_clicked }"
                                  @click="toggleItemDropdown">
                        <div class="drawer-icon-container">
                            <img src="@/assets/images/ic_items.svg" alt="">
                        </div>
                        <span class="md-list-item-text">Items</span>
                        <span class="float-right count">{{ num_of_items }}</span>
                        <span class="float-right menu-icon">
                            <img src="@/assets/images/drawer-menu-dropdown.svg" />
                        </span>
                    </md-list-item>
                    <transition name="fade" mode="in-out">
                        <div v-if="item_clicked" class="sub-item">
                            <!-- All Items -->
                            <div v-if="$route.name == 'item' && $route.params.cat == 'all'" @click="handleMaskClick">
                                <router-link to="/items/all" class="sub-item-active"><span class="span-selected">All Items</span></router-link>
                            </div>
                            <div v-else @click="handleMaskClick">
                                <router-link to="/items/all"><span class="span-unselected">All Items</span></router-link>
                            </div>

                            <!-- Create Item -->
                            <!--<div v-if="$route.name == 'create_item'" @click="handleMaskClick">-->
                            <!--<router-link to="/create_item" class="sub-item-active"><span class="span-selected">New Item</span></router-link>-->
                            <!--</div>-->
                            <!--<div v-else @click="handleMaskClick">-->
                            <!--<router-link to="/create_item"><span class="span-unselected">New Item</span></router-link>-->
                            <!--</div>-->
                        </div>
                    </transition>

                    <!-- Sign Out -->
                    <md-list-item>
                        <div class="drawer-icon-container">
                            <img src="@/assets/images/ic_logout.svg" alt="Logout">
                        </div>
                        <span class="md-list-item-text">
                            <b-link @click="logout"><span class="span-unselected">Sign Out</span></b-link>
                        </span>
                    </md-list-item>
                </md-list>

            </div>
            <div class="content" slot="content">
                <transition name="slide-fade" mode="out-in">
                    <router-view />
                </transition>
                <div>
                    <b-modal id="modal-center"
                             centered title="Subscription Expired."
                             hide-footer
                             v-model="showExpiryDialog"
                             no-close-on-backdrop
                    >
                        <p class="my-4">Financio Mobile is exclusive for Premium user only.
                            Please upgrade to Premium now to start issuing an invoice on the go!</p>

                        <p class="my-4"></p>
                        <div class="my-4 form-fnc">
                            <label>Switch Business</label>
                            <select style="min-width: 100%" v-model="app_company" @change="selectCompany(app_company)">
                                <option v-for="(value, key, index) in companies" v-bind:value="value.id">{{ value.display_name }}</option>
                            </select>
                        </div>
                        <button class="btn btn-block btn-fnc" @click="navigateToDesktop()">Subscribe</button>
                        <div class="modal-logout">
                            <label class="text-green" @click="logout">Logout</label>
                        </div>

                    </b-modal>
                </div>
            </div>
        </vue-drawer-layout>

    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'
    import * as $$ from "lodash";
    import listSvc from "./services/listService"
    import { createNamespacedHelpers } from 'vuex';

    export default {
        data() {
            return {
                app_company: null,
                invoice_clicked: false,
                item_clicked: false,
                num_contacts: null,
                num_invoices: null,
                num_items: null,
                drawerEnabled: false,
                showExpiryDialog: false
            }
        },
        computed: {
            isLoggedIn: function() {
                return this.$store.getters['auth/isLoggedIn'];
            },
            ...mapState('auth',[
                'menuVisible',
                'isActive',
            ]),
            ...mapState('user', [
                'user'
            ]),
            ...mapState('company', [
                'selectedCompany',
                'companies',
                'currentCompany'
            ]),
            num_of_contacts: function() {
                if(this.num_contacts > 9) {
                    return '9+'
                } else {
                    return this.num_contacts
                }
            },
            num_of_invoices: function() {
                if(this.num_invoices > 9) {
                    return '9+'
                } else {
                    return this.num_invoices
                }
            },
            num_of_items: function() {
                if(this.num_items > 9) {
                    return '9+'
                } else {
                    return this.num_items
                }
            }
        },
        methods: {
            ...mapMutations('auth', ['toggleDrawer', 'resetDrawer']),

            logoutDialog() {
                this.$confirmationToast("Sign Out?", "Are you sure you want to sign out?", this.logout, null);

            },
            logout: function() {
                this.$root.$emit('show-loading', true);
                this.$store.dispatch('auth/logout') 
                    .then(() => {

                        // Event tracking
                        this.$ga.event({
                            eventCategory: 'User',
                            eventAction: 'Logged out'
                        })

                        this.$root.$emit('show-loading', false);
                        this.$router.push('/login')
                    })
            },
            toggleMenu() {
                this.toggleDrawer()
            },
            toggleInvoiceDropdown() {
                this.invoice_clicked = !this.invoice_clicked
            },
            toggleItemDropdown() {
                this.item_clicked = !this.item_clicked
            },
            selectCompany(companyId) {
                this.$store.dispatch('company/setSelectedCompany', companyId);
                let company = null;
                $$.each(this.companies, function(item) {
                    if (companyId === item.id) {
                        company = item;
                    }
                });
                this.$store.dispatch('company/setCurrentCompany', company)

            },
            handleMaskClick() {
                this.$refs.drawer.toggle(false);
            },
            initDashboard() {
                this.drawerEnabled = true;
                let data = {
                    "requests":[{
                        "uri" : "/lists/counts",
                        "params": {
                            "company_id": this.selectedCompany
                        }
                    }]
                };
                listSvc.methods.readMixed(data)
                    .then(data => {
                        this.num_contacts = data.counts.contacts;
                        this.num_invoices = data.counts.invoices
                        this.num_items = data.counts.products;
                    })
            },
            navigateToDesktop (){
                window.open('https://app.financio.co', "_blank");
            }
        },
        beforeMount() {
            this.resetDrawer();
        },
        mounted: function() {
            var currentCompany = this.currentCompany;
            // this.showExpiryDialog = currentCompany.is_free;
            console.log("Mounted : App");
            //For displaying the current selected company in the drawer company menu
            this.app_company = this.selectedCompany

            //Check if invoice page subitem
            if(this.$route.name.includes("invoice")) {
                this.invoice_clicked = true
            }

            //Check if item page sub-item
            if(this.$route.name.includes("item")) {
                this.item_clicked = true
            }

        },
        created: function() {
            this.$root.$on('show-drawer', vars => {
                this.$refs.drawer.toggle(vars);
            });

            this.$root.$on('dashboard-init', vars => {
                this.initDashboard();
            });

            //Get Number of Contacts, Invoices & Items
            if (this.isLoggedIn) {
                this.initDashboard();
            } else {
                this.drawerEnabled = false;
            }
        },
    }
</script>

<style lang="scss">
    @import "@/assets/scss/app.scss";
    .modal-logout {
        text-align: center;
        margin-top: 10px;
        position: absolute;
        right: 20px;
        top: -45px;
    }
</style>
